{
  "ascending": "עולה",
  "ascendingSort": "מוין לפי עמודה {columnName} בסדר עולה",
  "collapse": "כווץ",
  "columnSize": "{value} פיקסלים",
  "descending": "יורד",
  "descendingSort": "מוין לפי עמודה {columnName} בסדר יורד",
  "expand": "הרחב",
  "resizerDescription": "הקש Enter כדי לשנות את הגודל",
  "select": "בחר",
  "selectAll": "בחר הכול",
  "sortable": "עמודה שניתן למיין"
}
